/* eslint-disable @typescript-eslint/return-await */
import { AxiosResponse } from "axios";

import API from "../api";
import BaseService from "./_base.service";
import { UserProject } from "../models/user.project";

const endpoint = "users/project";

export const UserProjectService = {
  ...BaseService<UserProject>({ endpoint }),
  
  async updateProjectView(userProjects?: UserProject[]): Promise<AxiosResponse<UserProject[]>> {
    return await API.put(`/${endpoint}/view`, userProjects);
  },
 
};
